import AntEmpty, { type EmptyProps as AntEmptyProps } from "antd/lib/empty";

export type EmptyProps = AntEmptyProps;

const EmptyComponent = (props: EmptyProps) => <AntEmpty {...props} />;

export const Empty = Object.assign(EmptyComponent, {
    PRESENTED_IMAGE_SIMPLE: AntEmpty.PRESENTED_IMAGE_SIMPLE,
    PRESENTED_IMAGE_DEFAULT: AntEmpty.PRESENTED_IMAGE_DEFAULT,
} as const);
